import { COURSE_STRUCTURES, STATUSES } from 'constants/common';

import { getTranslation } from 'helpers/getTranslation';

import { initialValues } from './ArcadePage.formConfig';

export const convertDataToForm = (data: any) => {
  if (!data) {
    return initialValues;
  }

  const commonData = {
    id: data.id,
    title: data.title || '',
    type: data.type,
    description: data.description || '',
    free: !data.premium,
    preview: data.preview,
    withResultPreview: data.resultPreview ? true : false,
    resultPreview: data.resultPreview,
    difficulty: data.difficulty,
    structure: data.structure,
    format: data.format || 'CHALLENGE',
    readOnly: data.status !== STATUSES.DRAFT,
  };

  if (data.structure === COURSE_STRUCTURES.LESSONS) {
    return {
      ...commonData,
      lessons: data.lessons,
    };
  }

  if (data.structure === COURSE_STRUCTURES.MODULES) {
    return {
      ...commonData,
      modules: data.modules,
    };
  }

  return commonData;
};

export const getContextItems = (status: any) => {
  switch (status) {
    case STATUSES.DRAFT: {
      return [
        {
          key: STATUSES.PUBLISHED,
          icon: 'published',
          text: getTranslation('arcade_page.helpers.publish'),
          value: STATUSES.PUBLISHED,
        },
        {
          key: 'PUBLISH_COURSE_AND_ALL_LESSONS',
          icon: 'published',
          text: getTranslation(
            'arcade_page.helpers.publish_aracde_and_lessons',
          ),
          value: 'PUBLISH_COURSE_AND_ALL_LESSONS',
        },
        {
          key: STATUSES.ARCHIVED,
          icon: 'archived',
          text: getTranslation('arcade_page.helpers.archived'),
          value: STATUSES.ARCHIVED,
        },
      ];
    }
    case STATUSES.PUBLISHED: {
      return [
        {
          key: STATUSES.DRAFT,
          icon: 'drafts',
          text: getTranslation('arcade_page.helpers.drafts'),
          value: STATUSES.DRAFT,
        },
      ];
    }
    case STATUSES.ARCHIVED: {
      return [
        {
          key: STATUSES.DRAFT,
          icon: 'drafts',
          text: getTranslation('arcade_page.helpers.restore'),
          value: STATUSES.DRAFT,
        },
      ];
    }
  }
};

export const getReadonlyArcadeText = (status: any) => {
  switch (status) {
    case STATUSES.PUBLISHED: {
      return getTranslation(
        'arcade_page.helpers.published_readonly_arcade_text',
      );
    }
    case STATUSES.ARCHIVED: {
      return getTranslation(
        'arcade_page.helpers.archived_readonly_arcade_text',
      );
    }
    default: {
      return '';
    }
  }
};
